import { fetchUserAttributes, FetchUserAttributesOutput } from 'aws-amplify/auth';

import { getCognitoConfiguration } from '../../api/config';

export function checkIsSignedIn(): boolean {
    const cognitoConfiguration = getCognitoConfiguration();
    for (let i = 0; 1; i++) {
        const key = localStorage.key(i);
        if (!key) break;
        else if (key.startsWith(`CognitoIdentityServiceProvider.${cognitoConfiguration.userPoolClientId}`)) return true;
    }
    return false;
}

export function getUserId(): string | undefined {
    try {
        const cognitoConfiguration = getCognitoConfiguration();
        for (let i = 0; 1; i++) {
            const key = localStorage.key(i);
            if (!key) break;
            else {
                const match = key.match(
                    `CognitoIdentityServiceProvider\\.${cognitoConfiguration.userPoolClientId}\\.(.*)\\.refreshToken`
                );
                if (match?.[1]) return match[1];
            }
        }
    } catch (error) {
        console.error(error);
        return undefined;
    }
    return undefined;
}

export enum CognitoUserAttributeName {
    email = 'email',
    emailVerified = 'email_verified',
    phoneNumber = 'phone_number',
    phoneNumberVerified = 'phone_number_verified',
    givenName = 'given_name',
    gender = 'gender',
    age = 'custom:age',
}

export function getCognitoUserAttributes(): Promise<FetchUserAttributesOutput> {
    return fetchUserAttributes();
}

export async function getCognitoUserAttribute(userAttributeName: CognitoUserAttributeName): Promise<string | undefined> {
    const userAttributes = await getCognitoUserAttributes();
    return userAttributes[userAttributeName];
}

export async function getEmailAndPhoneNumberStatuses(): Promise<{ emailVerified: boolean; phoneNumberVerified: boolean }> {
    const userAttributes = await getCognitoUserAttributes();
    const emailVerified = userAttributes[CognitoUserAttributeName.emailVerified] === 'true';
    const phoneNumberVerified = userAttributes[CognitoUserAttributeName.phoneNumberVerified] === 'true';
    return { emailVerified, phoneNumberVerified };
}

export function getCognitoAuthenticationData(): { [key: string]: string } {
    const authenticationData: { [key: string]: string } = {};
    // eslint-disable-next-line no-constant-condition
    for (let index = 0; 1; index++) {
        const key = localStorage.key(index);
        if (!key) break;
        if (key === '@AuthenticationStore:devStackMode' || key.startsWith('CognitoIdentityServiceProvider')) {
            const value = localStorage.getItem(key);
            if (value) authenticationData[key] = value;
        }
    }
    return authenticationData;
}
